import { toast } from "react-toastify";

// One toast per message, and one toast per failed request.
//
// - The same text of the same kind shows once while it's on screen (it gets a stable
//   toastId), so a failure reported by both the axios interceptor and the page, or by
//   two requests at once, doesn't stack up copies.
// - Every error toast is timestamped: the interceptor waits a moment before its generic
//   error toast and skips it when the page already said something more specific.
//
// installToastGuards() runs once at startup (index.js); tests that mock react-toastify
// don't call it, so their assertions see the plain calls.

let lastErrorToastAt = 0;

/** Whether an error toast was shown at or after `since` (a Date.now() value). */
export const errorToastShownSince = (since) => lastErrorToastAt >= since;

/** Records that an error toast is being shown (the guards call it for every toast.error). */
export const noteErrorToast = () => {
    lastErrorToastAt = Date.now();
};

const KINDS = ["success", "error", "info", "warn", "warning"];
let installed = false;

export function installToastGuards() {
    if (installed) return;
    installed = true;
    for (const kind of KINDS) {
        const show = toast[kind];
        if (typeof show !== "function") continue;
        toast[kind] = (content, options = {}) => {
            if (kind === "error") noteErrorToast();
            const toastId = options?.toastId ?? (typeof content === "string" ? `${kind}:${content}` : undefined);
            return show(content, toastId === undefined ? options : { ...options, toastId });
        };
    }
}
